import React, { useEffect, useState } from "react";
import "./index.css";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Toast from "../../subComponents/toast";
import VendorDetail from "./Components/VendorDetail";

const VendorDetails = (props) => {
  let { id } = useParams();
  const [vendorData, setVendorData] = useState({});
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { vendorList, vendorCount } = useSelector((state) => state?.beneficiary);
  const toastObject = useSelector((state) => state?.app?.toastObject);
console.log("windowWidthwindowWidth",windowWidth, vendorData);
  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  return (
    <div
      className="container topMargin"
      style={{
        height: "100%",
        marginLeft: "270px",
        maxWidth: windowWidth - 360,
      }}
    >
     
        <VendorDetail vendorData={vendorData}/>

        {toastObject.toastStatus ? (
        <Toast
          success={toastObject?.status}
          message={toastObject?.message}
          toggleModal={toastObject?.toggleModal}
          isOpen={toastObject?.toastStatus}
          name="trips"
          handleClose={toastObject?.handleClose}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default VendorDetails;
